import { firstValueFrom } from 'rxjs';

import { UserService } from '../services/user.service';
import { UserModel } from '../../../models/user.model';

export function fetchUser(userService: UserService) {
  return async (): Promise<UserModel | undefined> => {
    try {
      if (!window.location.href.includes('oauth2/token') && !window.location.href.includes('login?error=')) {
        const userPromise = firstValueFrom(userService.fetchUser());
        return await userPromise;
      }
      return undefined;
    } catch (error) {
      return undefined;
    }
  };
}
